import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { APP_CONFIG } from '@core-app/app.config';
import { BlockAbstractComponent } from '@gallaghercp/core-frontend';

@Component({
  selector: 'core-coro-cta-card-opt1',
  templateUrl: './coro-cta-card-opt1.component.html',
  styleUrl: './coro-cta-card-opt1.component.scss',
  standalone: false,
  encapsulation: ViewEncapsulation.None,
})
export class CoroCtaCardOpt1Component extends BlockAbstractComponent implements OnInit {
  imageUrl!: string;

  override ngOnInit(): void {
    super.ngOnInit();

    if (this.block.data.image_url) {
      this.imageUrl = APP_CONFIG.frontend + this.block.data.image_url;
    }
  }
}
